import { render, staticRenderFns } from "./PcGameListSection.vue?vue&type=template&id=aae0df16&scoped=true"
import script from "./PcGameListSection.vue?vue&type=script&lang=ts"
export * from "./PcGameListSection.vue?vue&type=script&lang=ts"
import style0 from "./PcGameListSection.vue?vue&type=style&index=0&id=aae0df16&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aae0df16",
  null
  
)

export default component.exports